import Svg from '../generated/Minus';
import { Icon, type IconProps } from './Icon';

export const MinusIcon = (props: IconProps) => <Icon component={Svg} name="minus" {...props} />;
